import React from "react";
import classNames from "classnames";
import { Column } from "components/table/Table";
import { Meet } from "types";
import get from "lodash/get";
import every from "lodash/every";

const AttemptCell = ({
  data,
  column,
  meet,
  style,
}: {
  data: any;
  column: Column;
  meet: Meet;
  style: React.CSSProperties;
}) => {
  const lifter = data;
  if (lifter.row === "header") {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else {
    const lift = column.lift;
    const attemptNumber = column.attemptNumber;
    if (!lift || !attemptNumber) {
      return null;
    }
    const attempt = get(lifter, ["lifts", lift, attemptNumber]);
    if (!attempt || !get(lifter, ["division", "lifts", lift])) {
      return null;
    }

    let isCurrentAttempt = false;
    every(meet.platforms, (platform) => {
      isCurrentAttempt =
        get(meet, ["platforms", platform._id, "currentAttemptId"]) ===
        get(attempt, "_id");

      if (isCurrentAttempt) {
        return false; //break loop
      }

      return true; // continue loop
    });

    return (
      <div
        style={style}
        className={classNames("table-cell-inner", attempt.result || "", {
          "current-attempt": isCurrentAttempt,
        })}
      >
        {get(attempt, column.key)}
      </div>
    );
  }
};

export default AttemptCell;
